import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {HomeComponent} from './home/home.component';
import {SharedModule} from '../shared/shared.module';
import {ToolboxComponent} from './toolbox/toolbox.component';
import {RouterModule} from '@angular/router';
import {ToolpagesComponent} from './toolpages/toolpages.component';
import {MaterialModule} from '../modules/material/material.module';
import {TextComponent} from './toolbox/text/text.component';
import {AudioComponent} from './toolbox/audio/audio.component';
import {ImageComponent} from './toolbox/image/image.component';
import {DocumentComponent} from './toolbox/document/document.component';
import {ScanComponent} from './toolbox/scan/scan.component';
import {ImgSelectComponent} from './toolbox/image/img-select/img-select.component';
import {ImgContentComponent} from './toolbox/image/img-content/img-content.component';
import {DocSelectComponent} from './toolbox/document/doc-select/doc-select.component';
import {DocContentComponent} from './toolbox/document/doc-content/doc-content.component';
import {ProgramComponent} from './program/program.component';
import {LearningPlatformComponent} from './learning-platform/learning-platform.component';
import {EducationGuidanceComponent} from './education-guidance/education-guidance.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {ProjectsComponent} from './projects/projects.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ToolMethodenkofferComponent} from './tool-methodenkoffer/tool-methodenkoffer.component';
import {ProjectListComponent} from './projects/project-list/project-list.component';
import {ProjectCreateComponent} from './projects/project-create/project-create.component';
import {ProjectEditComponent} from './projects/project-edit/project-edit.component';
import {ProjectDetailsComponent} from './projects/project-details/project-details.component';
import {CourseListComponent} from './program/course/course-list/course-list.component';
import {CourseCreateComponent} from './program/course/course-create/course-create.component';
import {CourseEditComponent} from './program/course/course-edit/course-edit.component';
import {CourseDetailsComponent} from './program/course/course-details/course-details.component';
import {PdfReaderComponent} from './program/pdf-reader/pdf-reader.component';
import {AdminComponent} from './admin/admin.component';
import {HttpClientModule} from '@angular/common/http';

import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MarkdownComponent} from './markdown/markdown.component';

import {MarkdownEditorModule} from '../modules/markdown-editor/markdown-editor.module';
import {RichTextEditorModule} from '../modules/rich-text-editor/rich-text-editor.module';
import {QuillModule} from 'ngx-quill';
import {CategoryComponent} from './category/category.component';
import {CategoryCreateComponent} from './category/category-create/category-create.component';
import {CategoryDetailsComponent} from './category/category-details/category-details.component';
import {CategoryEditComponent} from './category/category-edit/category-edit.component';
import {CategoryListComponent} from './category/category-list/category-list.component';
import {CourseCategoryEditComponent} from './course-category/course-category-edit/course-category-edit.component';
import {CourseCategoryListComponent} from './course-category/course-category-list/course-category-list.component';
import {
  ProjectCategoryCreateComponent
} from './project-category/project-category-create/project-category-create.component';
import {ProjectCategoryEditComponent} from './project-category/project-category-edit/project-category-edit.component';
import {ProjectCategoryListComponent} from './project-category/project-category-list/project-category-list.component';
import {InscriptionComponent} from './inscription/inscription.component';
import {CourseCategoryCreateComponent} from './course-category/course-category-create/course-category-create.component';
import {
  CourseCategoryDetailsComponent
} from './course-category/course-category-details/course-category-details.component';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {
  ProjectCategoryDetailComponent
} from './project-category/project-category-detail/project-category-detail.component';
import {CategoryCourseComponent} from './program/category-course/category-course.component';
import {DemokratiewerkstattComponent} from './demokratiewerkstatt/demokratiewerkstatt.component';
import {
  DemokratiewerkstattDetailsComponent
} from './demokratiewerkstatt/demokratiewerkstatt-details/demokratiewerkstatt-details.component';
import {
  DemokratiewerkstattEditComponent
} from './demokratiewerkstatt/demokratiewerkstatt-edit/demokratiewerkstatt-edit.component';
import {
  DemokratiewerkstattCreateComponent
} from './demokratiewerkstatt/demokratiewerkstatt-create/demokratiewerkstatt-create.component';
import {
  DemokratiewerkstattListComponent
} from './demokratiewerkstatt/demokratiewerkstatt-list/demokratiewerkstatt-list.component';
import {
  DemokratiewerkstattCategoryCreateComponent
} from './demokratiewerkstatt-category/demokratiewerkstatt-category-create/demokratiewerkstatt-category-create.component';
import {
  DemokratiewerkstattCategoryDetailComponent
} from './demokratiewerkstatt-category/demokratiewerkstatt-category-detail/demokratiewerkstatt-category-detail.component';
import {
  DemokratiewerkstattCategoryEditComponent
} from './demokratiewerkstatt-category/demokratiewerkstatt-category-edit/demokratiewerkstatt-category-edit.component';
import {
  DemokratiewerkstattCategoryListComponent
} from './demokratiewerkstatt-category/demokratiewerkstatt-category-list/demokratiewerkstatt-category-list.component';
import {ArchivComponent} from './archiv/archiv.component';

@NgModule({
  declarations: [
    HomeComponent,
    ToolboxComponent,
    ToolpagesComponent,
    TextComponent,
    AudioComponent,
    ImageComponent,
    DocumentComponent,
    ScanComponent,
    ImgSelectComponent,
    ImgContentComponent,
    DocSelectComponent,
    DocContentComponent,
    ProgramComponent,
    ArchivComponent,
    LearningPlatformComponent,
    EducationGuidanceComponent,
    ProjectsComponent,
    AboutUsComponent,
    ToolMethodenkofferComponent,
    ProjectListComponent,
    ProjectCreateComponent,
    ProjectEditComponent,
    ProjectDetailsComponent,
    CourseListComponent,
    CourseCreateComponent,
    CourseEditComponent,
    CourseDetailsComponent,
    PdfReaderComponent,
    AdminComponent,
    MarkdownComponent,
    CategoryComponent,
    CategoryCreateComponent,
    CategoryDetailsComponent,
    CategoryEditComponent,
    CategoryListComponent,
    CourseCategoryCreateComponent,
    CourseCategoryEditComponent,
    CourseCategoryListComponent,
    ProjectCategoryCreateComponent,
    ProjectCategoryEditComponent,
    ProjectCategoryListComponent,
    InscriptionComponent,
    CourseCategoryDetailsComponent,
    ProjectCategoryDetailComponent,
    CategoryCourseComponent,
    DemokratiewerkstattComponent,
    DemokratiewerkstattDetailsComponent,
    DemokratiewerkstattEditComponent,
    DemokratiewerkstattCreateComponent,
    DemokratiewerkstattListComponent,
    DemokratiewerkstattCategoryCreateComponent,
    DemokratiewerkstattCategoryDetailComponent,
    DemokratiewerkstattCategoryEditComponent,
    DemokratiewerkstattCategoryListComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    PdfViewerModule,
    MarkdownEditorModule,
    RichTextEditorModule,
    QuillModule.forRoot(),
    NgxDropzoneModule,
    NgOptimizedImage
  ]
})
export class PagesModule {
}
